import React from 'react';

const Footer = () => {

  const d=new Date()
  const nowYear=d.getFullYear();
 
  return (
        <footer className="bg-secondary  bg-gradient-to-r from-secondary to-primary  py-[60px]">
      <div className='footer max-w-[1170px] mx-auto'>
      <div className='mb-10'>
          <span className="footer-title">Services</span> 
          <a className="link link-hover">Branding</a>
          <a className="link link-hover">Design</a>
          <a className="link link-hover">Marketing</a>
          <a className="link link-hover">Advertisement</a>
        </div> 
        <div>
          <span className="footer-title">Company</span> 
          <a className="link link-hover">About us</a>
          <a className="link link-hover">Contact</a>
          <a className="link link-hover">Jobs</a>
          <a className="link link-hover">Press kit</a>
        </div> 
        <div>
          <span className="footer-title">Legal</span> 
          <a className="link link-hover">Terms of use</a>
          <a className="link link-hover">Privacy policy</a>
          <a className="link link-hover">Cookie policy</a>
        </div>


      </div>
        <div className=' text-center' >
    <p >Copyright © {nowYear} - All right reserved by Emon Ahmed</p>
  </div>
      </footer>
    );
};

export default Footer;